import React from 'react';
import { useTranslation } from 'react-i18next';
import { languages } from '../../i18n';
import { Globe } from 'react-feather';

const LanguageSelector: React.FC = () => {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLang = e.target.value;
    i18n.changeLanguage(newLang);
    localStorage.setItem('i18nextLng', newLang);
  };

  return (
    <div className="relative">
      <label htmlFor="language-select" className="block text-sm font-medium text-gray-700 mb-2">
        {t('common.selectLanguage')}
      </label>
      <div className="relative">
        <Globe className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
        <select
          id="language-select"
          value={i18n.language}
          onChange={handleLanguageChange}
          className="appearance-none w-full pl-10 pr-10 py-3 rounded-lg border border-gray-300
            bg-white text-base focus:outline-none focus:ring-2 
            focus:ring-green-500 focus:border-green-500 cursor-pointer
            hover:bg-gray-50 transition-all duration-200 shadow-sm"
          aria-label={t('common.selectLanguage')}
        >
          {languages.map((lang) => (
            <option key={lang.code} value={lang.code} className="py-2">
              {lang.nativeName}
            </option>
          ))}
        </select>
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
          <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;